<ng-container>
  <agr-page-toolbar [pageTitle]="pageTitle$ | async">
    <app-advertisement-management-header
      [text]="'shared.advertisement-management-header.my-advertisements-message' | translate"
    ></app-advertisement-management-header>
    <app-my-advertisements-table-header></app-my-advertisements-table-header>

    @if ((currentTab$ | async) === tabs.manureOffers) {
      <div>
        <app-active-offers-overview-table></app-active-offers-overview-table>
        <h3 class="text--primary text--light spacing--margin-left">
          {{ 'my-dashboard.closed-deals-title' | translate }}
        </h3>
        <app-closed-deals-offers-overview></app-closed-deals-offers-overview>
      </div>
    }

    @if ((currentTab$ | async) === tabs.manureRequests) {
      <div>
        <app-active-requests-overview-table></app-active-requests-overview-table>
        <h3 class="text--primary text--light spacing--margin-left">
          {{ 'my-dashboard.closed-deals-title' | translate }}
        </h3>
        <app-closed-requests-overview-table></app-closed-requests-overview-table>
      </div>
    }
  </agr-page-toolbar>
</ng-container>
